import { useState, useEffect } from 'react';
import { loadSchedule } from '../services/scheduleService';

export const useSchedule = () => {
    const [schedule, setSchedule] = useState(null);

    useEffect(() => {
        const fetchSchedule = async () => {
            const scheduleData = await loadSchedule();
            if (scheduleData) {
                setSchedule(scheduleData);
            }
        };

        fetchSchedule();
        const interval = setInterval(fetchSchedule, 60 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    return schedule;
};